import { useState } from 'react';
import {
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';

import COLORS from '../styles/colors.json';


const MenuHeading = ({ heading }) => {
  return (
    <MenuItem
      disabled={true}
      sx={{
        backgroundColor: COLORS.redDarker,
        color: COLORS.white,
        '&.Mui-disabled': {
          opacity: 1
        }
      }}
    >
      {heading}
    </MenuItem>
  )
}

export default (props) => {
  const {
    icon,
    menuItems,
    menuHeading,
    id,
    selectedNavButton,
    handleNavButtonClick,
    handleNavButtonClose
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
    
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    handleNavButtonClick(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
    handleNavButtonClose();
  };

  return (
    <>
      <IconButton
        sx={{ color: '#FFFFFF' }}
        className={selectedNavButton === id ? 'header-icon-enabled' : null}
        children={icon}
        onClick={handleClick}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuHeading ? <MenuHeading heading={menuHeading} /> : undefined}
        {menuItems}
      </Menu>
    </>
  )
}